import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import FAQ from './pages/FAQ';
import DashboardRouter from './pages/DashboardRouter';
import Trade from './pages/Trade';
import Transport from './pages/Transport';
import Investment from './pages/Investment';
import MultimodalTracking from './pages/MultimodalTracking';
import PermitsAndPartnershipModels from './pages/PermitsAndPartnershipModels';
import DirectMaritime from './pages/DirectMaritime';
import DirectRail from './pages/DirectRail';
import DirectRoad from './pages/DirectRoad';
import DirectAirCargo from './pages/DirectAirCargo';
import About from './pages/About';
import SiteLayout from './components/SiteLayout';
import RequireAuth from './components/RequireAuth';
import PublicOnly from './components/PublicOnly';

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<SiteLayout />}>
          {/* Public route: if already logged in, go to dashboard */}
          <Route element={<PublicOnly redirectTo="/dashboard" />}>
            <Route path="/" element={<Login />} />
          </Route>

          {/* Public FAQ: accessible whether logged in or not */}
          <Route path="/faq" element={<FAQ />} />

          {/* Protected routes: block access unless logged in */}
          <Route element={<RequireAuth redirectTo="/" />}>
            <Route path="/dashboard" element={<DashboardRouter />} />
            <Route path="/trade" element={<Trade />} />
            <Route path="/transport" element={<Transport />} />
            <Route path="/investment" element={<Investment />} />
            <Route path="/systems/tracking" element={<MultimodalTracking />} />
            <Route path="/systems/permits-partnership" element={<PermitsAndPartnershipModels />} />
            <Route path="/services/maritime" element={<DirectMaritime />} />
            <Route path="/services/rail" element={<DirectRail />} />
            <Route path="/services/road" element={<DirectRoad />} />
            <Route path="/services/air-cargo" element={<DirectAirCargo />} />
            <Route path="/about" element={<About />} />
          </Route>

          {/* Unknown routes */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
